import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@artprov/design-system';
import { useMatchingRoles } from './hooks/useMatchingRoles.js';
import { ROUTES } from './constants.js';
import { NoRoleAccessFallback } from '../../components/NoRoleAccessFallback.jsx';

/**
 * Componente de redirección para la ruta raíz "/".
 * Redirige al usuario a la sección de matching que corresponda según su rol:
 * - sge_contable o sge_view_all → /matching-bancario
 * - sge_legales → /matching-judicial
 *
 * Si no tiene ningún rol de matching, muestra un mensaje de acceso restringido.
 */
export function MatchingRouter() {
    const { canViewBancario, canViewJudicial, hasAnyMatchingAccess } = useMatchingRoles();
    const navigate = useNavigate();

    useEffect(() => {
        if (canViewBancario) {
            navigate(ROUTES.BANCARIO, { replace: true });
        } else if (canViewJudicial) {
            navigate(ROUTES.JUDICIAL, { replace: true });
        }
    }, [canViewBancario, canViewJudicial, navigate]);

    if (!hasAnyMatchingAccess) {
        return (
            <NoRoleAccessFallback />
        );
    }

    return (
        <div className="flex justify-center items-center h-screen">
            <Icon size="extra-large" variant="loading" />
        </div>
    );
}
